import "../component_style/about.css"

import { useEffect } from "react"
export default function About (){
 
    return(
        <div className="about_main" ><div>
            <h1 Style={"color:aliceblue;font-size:2rem; "} >About</h1>
            <div className="about_content" >

            <p Style={"color:aliceblue"}>
             
As a Software Engineer with one year of experience, specialize in front-end development, demonstrating proficiency in technologies such as React.js, Redux, and Redux Toolkit for state management. Additionally, possess expertise in web technologies like HTML5, CSS3, and tailwind CSS,making it possiable to create responsive and visually appealing user interfaces. Back-end skills include working with AWS services such as AppSync, Amplify, AWS SDK, and Lambda functions, allowing them to develop scalable solutions 
             for large-scale web applications. Furthermore also have experience implementing user authentication using Firebase, ensuring secure access to web applications. Overall, combination of front-end and back-end proficiency, along with experience in deploying and maintaining applications on AWS, makes them well-equipped to contribute effectively to complex web development projects.</p>
            <p Style={"color:orange;"}>Drop me a email - <a  Style={"color:orange;font-size:1.2rem"} href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=nikhilwalwatkar81@gmail.com" target="blank" > nikhilwawlwatkar81@gmail.com</a></p>
            </div>
            </div></div>
    )
}
